export const spinnerVariants = {
    s: {
        fontSize: '4px',
    },
    m: {
        fontSize: 'xl',
    },
    l: {
        fontSize: 'xxl',
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3Bpbm5lci12YXJpYW50cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy90aGVtZS9zcGlubmVyLXZhcmlhbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBLE1BQU0sQ0FBQyxNQUFNLGVBQWUsR0FBNkI7SUFDdkQsQ0FBQyxFQUFFO1FBQ0QsUUFBUSxFQUFFLEtBQUs7S0FDaEI7SUFDRCxDQUFDLEVBQUU7UUFDRCxRQUFRLEVBQUUsSUFBSTtLQUNmO0lBQ0QsQ0FBQyxFQUFFO1FBQ0QsUUFBUSxFQUFFLEtBQUs7S0FDaEI7Q0FDRixDQUFDIn0=